<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="img-ly-scene-import-modal-label">
                {{ $root.text('Import scene', null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-if="importing">
                <loading></loading>
                <div class="text-center mt-2">
                    {{ $root.text('Importing scene, please wait...', null, true) }}
                </div>
            </div>
            <div :style="'display: ' + (importing ? 'none' : 'block')">
                <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                <p class="mb-2">
                    {{ $root.text('Upload InDesign file to import. Must be .idml format.', null, true) }}
                </p>
                <vue-dropzone
                    v-if="dropzone_options"
                    ref="imgLySceneImportDropzone"
                    id="img-ly-scene-import-dropzone"
                    :options="dropzone_options"
                    v-on:vdropzone-sending="onSendingFile"
                    v-on:vdropzone-upload-progress="onProgressUpdate"
                    v-on:vdropzone-success="onFileUploaded"
                    v-on:vdropzone-error="onUploadError"
                    v-on:vdropzone-drag-over="onDragOver"
                    v-on:vdropzone-drag-leave="onDragLeave"
                    v-on:vdropzone-drop="onDragLeave"
                    v-on:vdropzone-file-added="onFileAdded"
                    :useCustomSlot=true
                >
                    <div v-if="file" class="dz-uploaded-file p-2 mb-1">
                        <div class="dz-thumbnail">
                            <span v-if="!file.preview_image">
                                <img
                                    :src="$root.imagePlaceholder(file.filename)"
                                    class="img-fluid"
                                    alt=""
                                >
                            </span>
                            <img
                                v-else
                                :src="file.preview_image"
                                class="img-fluid"
                                alt=""
                            >
                        </div>
                        <div class="dz-filename">{{ file.filename }}</div>
                        <div class="dz-size" v-html="$root.formatFileSize(file.file_size)"></div>
                        <div class="dz-remove">
                            <a
                                v-if="!importing"
                                href="#"
                                v-b-tooltip.hover
                                :title="$root.text('Delete', null, true)"
                                @click.prevent="removeUploadedFile()"
                            >
                                <i class="fal fa-trash-alt"></i>
                            </a>
                            <span v-if="importing"><i class="fal fa-trash-alt"></i></span>
                        </div>
                        <div
                            class="dz-upload-info"
                            :id="'upload-info' + file.id"
                            style="left: 160px"
                        >
                            <!--<i class="fal fa-clock mr-1"></i> Pending upload-->
                        </div>
                        <div
                            class="dz-progress"
                            :id="'upload-progress' + file.id"
                            style="width: calc(100% - 172px)"
                        >
                            <div class="dz-upload"></div>
                        </div>
                    </div>
                    <a
                        href="#"
                        class="dz-add-files"
                        id="img-ly-scene-import-add-files"
                        @click.prevent="doNothing()"
                        :style="dzAddFilesStyle()"
                    >
                        <i class="far fa-cloud-upload-alt font-size-20 mr-1"></i>
                        {{ $root.text('Click or drop IDML file here to upload', null, true) }}
                    </a>
                </vue-dropzone>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone';
    import CreativeEngine from "@cesdk/engine";
    import { IDMLParser, addGoogleFontsAssetLibrary } from "@imgly/idml-importer";
    export default {
        components: {
            'vue-dropzone': vue2Dropzone,
            CreativeEngine,
            IDMLParser,
            addGoogleFontsAssetLibrary
        },
        data () {
            return {
                errors: false,
                uploading: false,
                importing: false,
                dropzone_options: null,
                file: null
            }
        },
        mounted () {
            var vm = this;
            this.dropzone_options = {
                url: this.$root.app.api_url + '/' + this.$root.app.client_id + '/upload-v2',
                /*acceptedFiles: 'application/octet-stream,application/idml,application/zip,'
                    + 'application/x-zip-compressed,application/vnd.adobe.indesign-idml-package,.idml',*/
                acceptedFiles: '.idml',
                createImageThumbnails: true,
                maxThumbnailFilesize: 20,
                thumbnailWidth: 50,
                thumbnailHeight: 50,
                uploadMultiple: false,
                parallelUploads: 1,
                chunking: true,
                forceChunking: true,
                parallelChunkUploads: false,
                chunkSize: 10000000,
                retryChunks: true,
                retryChunksLimit: 5,
                maxFilesize: (100 * 1000 * 1000),
                autoProcessQueue: false,
                timeout: 0,
                clickable: '#img-ly-scene-import-add-files',
                headers: {
                    'Authorization': 'Bearer ' + this.$root.token
                },
                accept: function (file, done) {
                    const ext = vm.$root.getFileExtension(file.name);
                    if (ext != 'idml') {
                        done('File type not accepted');

                        return null;
                    }
                    done();
                }
            };
        },
        watch: {
            //
        },
        methods: {
            reset: function () {
                this.errors = false;
                this.uploading = false;
                this.importing = false;
                this.file = null;
            },
            doNothing: function () {
                return false;
            },
            dzAddFilesStyle: function () {
                if (!this.file) {
                    return 'display: block';
                }

                return 'display: none';
            },
            onFileAdded: function (file) {
                if (!this.uploading) {
                    this.errors = false;
                }
                if (this.file) {
                    this.$refs.imgLySceneImportDropzone.removeFile(file);

                    return null;
                }

                // Check file size.
                if (file.size > this.dropzone_options.maxFilesize) {
                    this.$refs.imgLySceneImportDropzone.removeFile(file);
                    const appComponent = this.$root.findComponent(this.$root, 'main-app');
                    appComponent.message = {
                        type: 'error',
                        title: this.$root.text('Maximum upload size exceeded', null, true),
                        text: this.$root.text('The maximum size of the image you can upload is {size}.',
                            { size: this.$root.formatFileSize(this.dropzone_options.maxFilesize) }, true) + ' '
                            + this.$root.text('The size of {filename} is {size}.',
                            { filename: file.name, size: this.$root.formatFileSize(file.size) }, true)
                    };
                    $('#message-modal').modal('show');
                    $('.modal-backdrop').css({ 'z-index': '1060', 'opacity': '0.25' });

                    return null;
                }

                this.errors = false;
                let newFile = {
                    id: file.upload.uuid,
                    filename: file.name,
                    file_type: file.type,
                    file_size: file.size,
                    upload: {
                        progress: 0,
                        bytes_sent: 0
                    },
                    preview_image: (file.dataURL || null)
                };
                this.file = newFile;
                var vm = this;
                setTimeout(function () {
                    if (vm.file) {
                        vm.$refs.imgLySceneImportDropzone.processQueue();
                        vm.uploading = true;
                        $('#upload-info' + vm.file.id).html(vm.$root.text('Preparing upload...', null, true));
                    }
                }, 500);
            },
            onDragOver: function (event) {
                $('#img-ly-scene-import-dropzone').addClass('dz-drag-highlight');
            },
            onDragLeave: function (event) {
                $('#img-ly-scene-import-dropzone').removeClass('dz-drag-highlight');
            },
            onSendingFile: function (file, xhr, formData) {
                formData.append('id', file.upload.uuid);
                //formData.append('create_preview', '2000x2000');
            },
            onProgressUpdate: function (file, progress, bytesSent) {
                if (!this.file) {
                    return null;
                }
                if ((progress < 100) && (this.file.id == file.upload.uuid)) {
                    if (isNaN(bytesSent)) {
                        bytesSent = file.size * (progress / 100);
                    }
                    this.file.upload.progress = progress;
                    this.file.upload.bytes_sent = bytesSent;
                    $('#upload-info' + this.file.id)
                        .html(this.$root.formatFileSize(bytesSent) + ' ' + progress.toFixed(1) + '%');
                    $('#upload-progress' + this.file.id + ' > div').css('width', progress + '%');
                }
            },
            onFileUploaded: function (file, response) {
                if (!this.file) {
                    return null;
                }
                if (this.file.id == file.upload.uuid) {
                    this.file.upload.progress = 100;
                    this.file.upload.bytes_sent = file.size;
                    $('#upload-info' + this.file.id).html(this.$root.text('Finalising upload...', null, true));
                    $('#upload-progress' + this.file.id + ' > div').css('width', '100%');
                    if (!this.file.preview_image) {
                        this.file.preview_image = (file.dataURL || null);
                    }

                    this.getUploadInfo(this.file.id);
                    this.$refs.imgLySceneImportDropzone.removeFile(file);
                }
            },
            getUploadInfo: function (fileId) {
                /**
                 * Send request to API.
                 */
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/upload-info/' + fileId;
                var vm = this;

                axios({
                    url: url,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    if (vm.file.id != response.data.file_id) {
                        return null;
                    }
                    vm.file.temp_file = response.data.temp_file;
                    vm.onUploadComplete();
                    $('#upload-info' + vm.file.id).html('');
                })
                .catch(function (error) {
                    // Do anything?
                });
            },
            onUploadComplete: function () {
                this.uploading = false;
                this.importing = true;
                this.downloadFile();
            },
            onUploadError: function (file, message, xhr) {
                if (file.status != 'canceled') {
                    if (!file.accepted || (message == 'File type not accepted')) {
                        let error = this.$root.text('Invalid file type: {filename}', { filename: file.name }, true);
                        if (!this.errors) {
                            error += '<br><br>' + this.$root.text('Please choose an IDML file.', null, true);
                            this.errors = error;
                        } else {
                            this.errors = error + '<br>' + this.errors;
                        }
                        this.$refs.imgLySceneImportDropzone.removeFile(file);
                        this.file = null;
                    }
                    if (!this.errors) {
                        this.errors = this.$root.text('Something went wrong, please try again', null, true);
                    }
                }
                this.uploading = false;
                console.log(file, message);
            },
            removeUploadedFile: function(confirmed = false) {
                if (confirmed) {
                    const removeUploadFileId = (this.file.upload.progress < 100) ? this.file.id : null;

                    this.file = null;
                    this.errors = false;

                    if (removeUploadFileId) {
                        this.$refs.imgLySceneImportDropzone.getUploadingFiles().forEach((file) => {
                            if (file.upload.uuid == removeUploadFileId) {
                                this.$refs.imgLySceneImportDropzone.removeFile(file);
                            }
                        });
                        this.$refs.imgLySceneImportDropzone.getQueuedFiles().forEach((file) => {
                            if (file.upload.uuid == removeUploadFileId) {
                                this.$refs.imgLySceneImportDropzone.removeFile(file);
                            }
                        });
                    }
                
                    return null;
                }

                const appComponent = this.$root.findComponent(this.$root, 'main-app');
                appComponent.confirm_delete = {
                    title: this.$root.text('Delete file', null, true),
                    text: this.$root.text(
                        'Are you sure you want to delete: {filename}?',
                        { filename: this.file.filename },
                        true
                    ),
                    component: this,
                    action: 'delete-file'
                };
                $('#confirm-delete-modal').modal('show');
                $('.modal-backdrop').css({ 'z-index': '1060', 'opacity': '0.25' });
            },
            confirmDelete: function (action) {
                if (action == 'delete-file') {
                    this.removeUploadedFile(true);
                }
            },
            downloadFile: function () {
                /**
                 * Send request to API.
                 */
                const data = {
                    item_type: 'temp_file',
                    item_id: 0,
                    file_path: this.file.temp_file,
                    file_type: 'application/vnd.adobe.indesign-idml-package',
                    download_filename: 'scene.idml'
                };
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/request-download-token';
                var vm = this;

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    const url = vm.$root.app.api_url + '/' + vm.$root.app.client_id + '/download/'
                        + response.data.token;
                    //window.location.href = url;
                    console.log('Download URL:', url);
                    vm.importIdml(url);
                })
                .catch(function (error) {
                    if (error.response.status == 401) {
                        // missing/lost API token - logout user
                        $('#img-ly-scene-import-modal').modal('hide');
                        vm.$root.doLogout();
                    }
                    vm.errors = error.response.data.error
                        || vm.$root.text('Something went wrong, please try again', null, true);
                });
            },
            async importIdml(url) {
                const blob = await fetch(url).then((res) => res.blob());

                const engine = await CreativeEngine.init({
                    license: this.$root.app.img_ly_license_key
                });

                // We use google fonts to replace well known fonts in the default font resolver.
                await addGoogleFontsAssetLibrary(engine);

                const parser = await IDMLParser.fromFile(engine, blob, (content) =>
                    new DOMParser().parseFromString(content, "text/xml")
                );

                await parser.parse();

                /*const image = await engine.block.export(
                    engine.block.findByType("//ly.img.ubq/page")[0],
                    'image/png'
                );
                const sceneExportUrl = window.URL.createObjectURL(image);
                console.log("The imported IDML file looks like:", sceneExportUrl);*/

                var vm = this;
                engine.scene.saveToString(['blob', 'bundle', 'file', 'http', 'https', 'opfs', 'data'])
                .then(response => {
                    const appComponent = vm.$root.findComponent(vm.$root, 'main-app');
                    engine.dispose();
                    appComponent.showImgLySceneEditor(response);
                    $('#img-ly-scene-import-modal').modal('hide');
                })
                .catch(function (error) {
                    vm.importing = false;
                    vm.file = null;
                    vm.errors = error;// vm.$root.text('Something went wrong, please try again', null, true);
                });
            }
        }
    }
</script>
<style scoped>
    #img-ly-scene-import-dropzone {
        min-height: 126px;
    }

    #img-ly-scene-import-add-files {
        padding-top: 45px;
    }

    .dz-uploaded-file {
        cursor: default;
    }
</style>
